import { DtoExt } from '@/classes/scenario/DtoExt';
import { ScenarioRevenue } from '@/dto/scenario/ren-fr/revenue/ScenarioRevenue';

export class ScenarioRevenueExt extends DtoExt {

  public contractType: string | null = null;
  public caseType: string | null = null;
  public ppa1Duration: number | null = null;
  public ppa1RateInflationIndex: number | null = null;
  public ppa1ProductionSold: number | null = null;
  public leaseDuration: number | null = null;
  public selfConsumptionPlantRent: number | null = null;
  public leaseInflation: number | null = null;
  public activePrePPA: string | null = 'COMEX continued';
  public activePostPPA: string | null = 'COMEX continued';
  public saleCapacityCertificate: boolean | null = false;
  public marketCapacityPrice: string | null = 'Scénario interne';
  public merchantPeriodGuarantee: boolean | null = true;
  public amountOfOrigin: number | null = 2;

  private static fieldList = [
    'contractType',
    'caseType',
    'ppa1Duration',
    'ppa1RateInflationIndex',
    'ppa1ProductionSold',
    'leaseDuration',
    'selfConsumptionPlantRent',
    'leaseInflation'
  ];

  constructor(options?: Partial<ScenarioRevenueExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public static fromDto(dto: ScenarioRevenue): ScenarioRevenueExt {
    return new ScenarioRevenueExt(Object.fromEntries(
      this.fieldList
        // eslint-disable-next-line
        .filter(k => dto.hasOwnProperty(k as keyof ScenarioRevenue))
        .map((k) => [k, dto[k as keyof ScenarioRevenue]])
    ));
  }

  public toDto(): ScenarioRevenue {
    return new ScenarioRevenue(Object.fromEntries(
      ScenarioRevenueExt.fieldList
        // eslint-disable-next-line
        .filter(k => this.hasOwnProperty(k as keyof ScenarioRevenueExt))
        .map((k) => [k, this[k as keyof ScenarioRevenueExt]])
    ));
  }
}
